<script>
import api from "@/services/api/api-cm"
import Svc from '../../../course_managment/core/cm-service'
import { dateFormating, convertToDefaultDateFormat } from "../../../../../../util"

class FormattedDatetimeExam {
  constructor(exam) {
    this.exam = exam
  }

  convert() {
    return {
      ...this.exam,
      text: `${this.exam.location} ${convertToDefaultDateFormat(this.exam.date)} ${this.exam.timeFrom} - ${this.exam.timeTo}`
    }
  }
}

export default {
  name: 'ExamChoose',
  render() {
    return this.$scopedSlots.default({
      hasCourse: this.hasCourse,
      loading: this.loading,
      list: this.list,
      loadData: this.loadData,
      addToList: this.addToList,
      selectedExam: this.selectedExam,
      loadWithInform: this.loadWithInform,
      hasExam: this.hasExam
    })
  },

  props: {
    courseID: {
      type: Number
    },
    activeExam: Object
  },

  data: () => ({
    svc: new Svc(api),
    loading: false,
    list: []
  }),

  computed: {
    hasCourse() {
      if(this.courseID) return true
      return false
    },

    selectedExam() {
      if(!this.activeExam || !this.activeExam.ID) return {}
      return this.list.find(item => item.ID === this.activeExam.ID)
    },

    hasExam() {
      if(!this.activeExam || !this.activeExam.ID) return false
      return true
    },
  },

  mounted() {
    if(this.courseID) this.loadData(this.courseID)
  },

  methods: {

    async loadWithInform(data) {
      await this.loadData(data)
      this.$emit('loaded', this.list)
    },

    async loadData(data) {
      try {
        this.loading = true
        let res = await this.svc.getConfig(data)
        this.list = res.map(item => new FormattedDatetimeExam(item).convert())
      } catch (error) {
        console.log(error)
      }
      finally {
        this.loading = false
      }
    },

    addToList(item) {
      this.list.push(item)
    }
  }
}
</script>